import { motion } from "framer-motion";
import { HeartPulse, ShieldCheck, Car, PiggyBank, Umbrella } from "lucide-react";
import { useSite } from "@/context/SiteContext";

const EASE = [0.22, 1, 0.36, 1];
const ICONS = { HeartPulse, ShieldCheck, Car, PiggyBank };

export const Services = () => {
  const { content, t, lang } = useSite();

  return (
    <section id="services" data-testid="services-section" className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: EASE }}
          className="max-w-2xl"
        >
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-orange-500">
            {lang === "zh" ? "我们的服务" : "What We Do"}
          </p>
          <h2 className="mt-4 font-display font-extrabold tracking-tight text-4xl sm:text-5xl text-slate-900">
            {lang === "zh" ? "守护生活的每一面" : "Covering Every Side of Life"}
          </h2>
        </motion.div>

        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {content.services.map((svc, i) => {
            const Icon = ICONS[svc.icon] || Umbrella;
            return (
              <motion.div
                key={svc.id || i}
                data-testid={`service-card-${i}`}
                initial={{ opacity: 0, y: 32 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.7, delay: i * 0.1, ease: EASE }}
                className="group rounded-3xl bg-white border border-slate-100 p-8 shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:-translate-y-2 hover:border-orange-200 hover:shadow-[0_20px_40px_rgb(249,115,22,0.12)] transition-[transform,box-shadow,border-color] duration-400"
              >
                <div className="w-14 h-14 rounded-2xl bg-sky-100 grid place-items-center text-sky-500 group-hover:bg-orange-500 group-hover:text-white transition-[background-color,color] duration-400">
                  <Icon size={26} strokeWidth={2.2} />
                </div>
                <h3 className="mt-6 font-display font-bold text-xl text-slate-900">{t(svc, "title")}</h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-600">{t(svc, "desc")}</p>
                <span className="mt-6 block font-mono2 text-xs text-slate-300 group-hover:text-orange-400 transition-colors duration-300">
                  0{i + 1}
                </span>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
